import { Circle, ExpandMore, PlaceOutlined } from '@mui/icons-material'
import { AccordionSummary, Grid, Typography } from '@mui/material'

import useStyles from '../index.styles'

const SummaryTopLevel = ({ label, count, hasAlert, showPlaceIcon = true }: { label: string; count: number; hasAlert: boolean; showPlaceIcon?: boolean }) => {
  const classes = useStyles
  return (
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Grid container={true} size={12} sx={[classes.accordionSummaryGrid, { paddingLeft: 0 }]}>
        <Grid container={true} sx={classes.accordionSummaryContent}>
          {showPlaceIcon && <PlaceOutlined sx={classes.placeIcon} />}
          <Typography component="span" variant="subtitle1" sx={classes.boldText500}>
            {label}
          </Typography>
        </Grid>
        <Grid container={true} sx={classes.accordionSummaryContent}>
          {hasAlert && <Circle sx={classes.alertCircle} aria-label="There are alerts" />}
          <Typography variant="body2" sx={classes.boldText500}>
            ({count})
          </Typography>
        </Grid>
      </Grid>
    </AccordionSummary>
  )
}

const SummaryNested = ({ label, count }: { label: string; count: number }) => {
  const classes = useStyles
  return (
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Grid container={true} size={12} sx={classes.accordionSummaryGrid}>
        <Typography component="span" variant="subtitle1" sx={classes.boldText500}>
          {label}
        </Typography>
        <Typography variant="body2" sx={classes.boldText500}>
          ({count})
        </Typography>
      </Grid>
    </AccordionSummary>
  )
}

const AccordionGroup = {
  SummaryTopLevel,
  SummaryNested,
}

export default AccordionGroup
